function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useEffect, useState } from 'react';
import { getContacts } from "../../../api/requests/contacts";
import { useDidUpdateEffect } from "../../../hooks/useDidUpdateEffect";
import { useAuth } from "../../Auth";
export const useAllUsers = () => {
  const _useAuth = useAuth(),
        user = _useAuth.user;

  const _useState = useState(null),
        _useState2 = _slicedToArray(_useState, 2),
        contacts = _useState2[0],
        setContacts = _useState2[1];

  const _useState3 = useState(1),
        _useState4 = _slicedToArray(_useState3, 2),
        page = _useState4[0],
        setPage = _useState4[1];

  const _useState5 = useState(0),
        _useState6 = _slicedToArray(_useState5, 2),
        totalPages = _useState6[0],
        setTotalPages = _useState6[1];

  const _useState7 = useState(''),
        _useState8 = _slicedToArray(_useState7, 2),
        searchValue = _useState8[0],
        setSearchValue = _useState8[1];

  const fetchContacts = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(function* (page, searchValue) {
      const _yield$getContacts = yield getContacts({
        page,
        searchValue
      }),
            contacts = _yield$getContacts.contacts,
            totalPages = _yield$getContacts.totalPages;

      setContacts(contacts.filter(contact => contact.id !== user.id));
      setTotalPages(totalPages);
    });

    return function fetchContacts(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  useEffect(() => fetchContacts(page, searchValue), []);
  useDidUpdateEffect(() => {
    setContacts(null);
    setTotalPages(0);
    setPage(1);
    fetchContacts(1, searchValue);
  }, [searchValue]);
  useDidUpdateEffect(() => {
    setContacts(null);
    fetchContacts(page, searchValue);
  }, [page]);
  return {
    contacts,
    searchValue,
    setSearchValue,
    pagination: {
      page,
      count: totalPages,
      onChange: (_, page) => setPage(page)
    }
  };
};